import basicValidation from '../../namespace/relation/doingValidate_namespace_relation';
import { validateSendNotificationHttp } from '../customerWorkflow/doingValidate_rulesEngine_customerWorkflow';

export default {
    verb: 'doingValidate',
    namespace: 'rulesEngine',
    relation: 'notificationRule',
    priority: (basicValidation.priority || 0) + 5, // we want this to run BEFORE basic validation
    description: 'validate new notification rule creation',
    logic
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").WorkflowStack} WorkflowStack
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @template {{ newRecord: { [key: string]: any } }} T
 * @param {{
 *   data: T;
 *   prerequisiteResults: object[];
 *   context: Context;
 *   workflowStack: WorkflowStack[];
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 * @returns {Promise<T>}
 */
async function logic({ data, context }) {
    // if any workflowAction is send_notification_http and does not have a url and body, then throw a validationError.
    const actions = data.newRecord.actions || [];
    validateSendNotificationHttp(actions, context);
    return data;
}
